var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_43_3366)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#D3DCEA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.35302C7.51938 8.04298 7.73253 7.43453 8.43011 7.48104H18.08C18.3513 7.55855 18.8823 7.89959 18.8357 8.64368V12.3182",
    stroke: "#7C8092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7488 15.5615H8.0519C7.66435 15.5615 7.55762 15.3522 7.55762 14.5151C7.55762 14.3756 7.55762 10.2327 7.55762 8.17871",
    stroke: "#7C8092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7334 7.83008L12.384 11.0855C12.694 11.2211 13.4768 11.3878 14.1279 10.9692L18.6622 7.83008",
    stroke: "#7C8092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0608 15.3126C21.0608 17.3374 19.4194 18.9787 17.3946 18.9787C15.3699 18.9787 13.7285 17.3374 13.7285 15.3126C13.7285 13.2879 15.3699 11.6465 17.3946 11.6465C19.4194 11.6465 21.0608 13.2879 21.0608 15.3126Z",
    stroke: "#7C8092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3696 15.4612L16.8259 16.5231L19.2914 14.2708",
    stroke: "#7C8092"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_43_3366",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_3366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43_3366",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSentIcon);
export default __webpack_public_path__ + "static/media/mail-sent-icon.5363578fc3ba663fce7b5aba4727c757.svg";
export { ForwardRef as ReactComponent };